interface TranslatedRoutes {
    login: string;
    register: string;
    prescribe: string;
}

const DEFAULT_ROUTES: TranslatedRoutes = {
    login: '/login',
    register: '/register',
    prescribe: '/prescribe',
};

export function useTranslatedRoutes(): Ref<TranslatedRoutes> {
    const routes = useState<TranslatedRoutes>('translated-routes', () => DEFAULT_ROUTES);

    return routes;
}
